module.exports = __webpack_public_path__ + "static/assets/199537b16130f2421f71ba307c506f31.svg";